export default function LoadingProjectPhase() {
  return (
    <div className='container mx-auto'>
      <div className='w-full mx-auto mt-8'>
        <div className='animate-pulse flex space-x-4 my-4'>
          <div className='w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-neutralColor-light rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
          <div className='w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-neutralColor-light rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
          <div className='w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-neutralColor-light rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
          <div className='w-1/4 space-y-4 py-1'>
            <div className='space-y-2'>
              <div className='h-48 bg-neutralColor-light rounded p-5'>
                <div className='h-4 bg-neutralColor-light w-1/2 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/3 mb-5 rounded'></div>
                <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full flex gap-4 animate-pulse'>
          <div className='w-1/2 h-48 bg-neutralColor-light p-4 rounded-md'>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-1/3 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-2/3 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-2/5 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
          </div>
          <div className='w-1/2 h-48 bg-neutralColor-light p-4 rounded-md'>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-1/2 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-1/3 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-2/3 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
            <div className='flex justify-between mb-5'>
              <div className='h-4 bg-neutralColor-light w-2/5 rounded'></div>
              <div className='h-6 w-6 rounded-full bg-neutralColor-light'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
